import { Box, Divider, Stack } from '@ui'
import { ServerSpaceMetadata } from 'routes/EditSpaceMetadata/schema/spaceMetadata.schema'
import { Paragraph } from 'ui/components/Text/Paragraph'

export const TownFAQ = (props: { faq: ServerSpaceMetadata['faq'] }) => {
    if (!props.faq?.length) {
        return null
    }
    return (
        <>
            <Divider />
            <Box gap="lg">
                <Paragraph strong size="lg" color="default">
                    FAQs
                </Paragraph>
                <Stack gap="md">
                    {props.faq.map((faq) => (
                        <Stack key={faq.question}>
                            <Paragraph strong>{faq.question}</Paragraph>
                            <Paragraph color="gray2">{faq.answer}</Paragraph>
                        </Stack>
                    ))}
                </Stack>
            </Box>
        </>
    )
}
